import fetch from "../utils/fetch";

// 梯控系统

// 获取项目与楼栋
export function getBuildInfo() {
    return fetch({
        method: 'GET',
        url: 'projectBasics/buildInfo'
    })
}


// IC卡列表查询
export function getIcList(data) {
    return fetch({
        method: 'POST',
        url: 'elevIcCard/getIcCardList',
        data
    })
}

// 添加IC卡
export function addIcList(data) {
    return fetch({
        method: 'POST',
        url: 'elevIcCard/saveIcCard',
        data
    })
}

// 编辑IC卡
export function editIc(data){
    return fetch({
        method: 'POST',
        url: 'elevIcCard/updateIcCard',
        data
    })
}

// 删除IC卡
export function delIc(data){
    return fetch({
        method: 'POST',
        url: 'elevIcCard/delIcCard',
        data
    })
} 

// 获取设备ID
export function getDeviceId(params) {
    return fetch({
        method: 'GET',
        url: 'elevIcCard/getDeviceListByBuildingFid',
        params
    })
}



// 查询设备列表/刷新设备列表
export function getDeviceList(data) {
    return fetch({
        method: 'POST',
        url: 'elevDevice/queryDeviceList',
        data
    })
}

// 绑定设备
export function addDevice(data) {
    return fetch({
        method: 'POST',
        url: 'elevDevice/addDevice',
        data
    })
}

// 编辑设备
export function updateDevice(data) {
    return fetch({
        method: 'POST',
        url: 'elevDevice/updateDevice',
        data
    })
}

// 删除设备
export function delDevice(data) {
    return fetch({
        method: 'POST',
        url: 'elevDevice/deleteDevice',
        data
    })
}

// 员工远程开门
export function openDoor(data) {
    return fetch({
        method: 'POST',
        url: 'elevDevice/remoteOpenDoor',
        data
    })
}

// 获取设备信息
export function getDeviceInfo(params) {
    return fetch({
        method: 'GET',
        url: 'elevDevice/getDeviceByDeviceId',
        params
    })
}


// 查询日志
export function getLogsList(data) {
    return fetch({
        method: 'POST',
        url: 'elevCallBack/getCallBackList',
        data
    })
}
